export default {
  login: "请登录访问更多内容...",
  password_rule: "* 密码区分大小写，长度必须为6到10个字符。",
  nickname_rule: "* 您可以为显示和登录设置昵称（6到15个字母或数字）。请注意，您只能将此昵称设置一次。一旦设置，您就无法修改或取消它。",
  change_password_succeed: "您已成功更改密码。",
  add_secondary_succeed: "您已成功添加昵称。",
  succeed: "您已成功完成操作！",
  failed: "你未能完成这个动作！",
  no_information_available: "无信息。",
  select_display_language: "选择您偏好的默认语言。",
  select_odds_type: "选择您偏好的默认赔率类型显示。",
  select_page_type: "选择您偏好的页面类型显示于今日及早盘页面。",
  select_show_score_map: "投注时系统将启用自动显示盈利预测图。",
  select_default_event_sorting: "选择您偏好的默认赛事排序显示。",
  select_market_type: "选择您偏好的默认盘口类型显示。",
  select_page_size: "选择首选页面大小。",
  change_sports_menu_order: "请拖拽运动来改变所需的体育赛事排序。",
  view_outstanding_bets_in_bet_list: "最新未完成投注可能需要一些时间处理，可至投注历史查询您的投注纪录。",
  time_display_in_gmt_plus_8: "显示时间为GMT+8时区",
  select_default_stake: "启用系统自动输入您自订的投注额及最后投注的投注额。",
  bet_empty: "您的投注单是空的。请点选画面上的赔率进行下注。",
  no_event: "当前没有可投注的赛事或游戏。您可先至其他运动或游戏进行下注，或稍后回来查看。",
  no_bets: "没有任何进行中的投注",
  no_waiting: "没有任何等待中的投注",
  no_void: "没有任何作废的投注",
  gmt8: "显示时间为GMT+8时区。",
  confirm_bet: "确定下注?",
  match_not_started: "比赛未开始",
  odds_changed: "赔率已经改变",
  to: "到",
  dnsta: "不再显示。",

  login2: "若想要登录并访问我们的游戏，您必须先注册帐户。如果您已经有了帐户，请继续进行登录。",

  no_video: "%% 未找到视频",

  days: "天",
  hours: "小时",
  mins: "分钟",
  secs: "秒",

  room_full: "此房间已满",
  room_joined: "您已成功加入房间",
  no_room: "没有可加入的房间。请选择其他选项并重新搜索或稍后再回来。",
  are_you_sure: "您确定要执行此操作吗？",
  no_matches: "现在没有可选择的比赛或游戏。",
  pin_code: "例如：123456",
  accept_terms: "勾选即表示您确认已阅读、理解并同意上述条款和条件。",
  accept_required: "在继续之前，请阅读、理解并同意<br />上述条款和条件。",
  my_room: "我的房间",
  not_winning_prize_in_this_tournament: "您在本次锦标赛中，没有获得任何奖项。",
  you_did_not_join_this_room: "您没有加入此房间。",
  room_password_rule: "* PIN码必须是6位数字。",
  jan: "一月",
  feb: "二月",
  mar: "三月",
  apr: "四月",
  may: "五月",
  jun: "六月",
  jul: "七月",
  aug: "八月",
  sep: "九月",
  oct: "十月",
  nov: "十一月",
  dec: "十二月",
  must_accept_better_odds: "默认情况下，下注将自动接受更好的赔率。请查阅条款和条件获取更多信息。",
  maintenance_notice: "目前，我们正在进行系统维护。请稍后再试。",
  deduct_confirm: "这将开始游戏，您的信用将被扣除。<br />您确定要继续吗？",
  no_more_bets: "无更多投注。",
  over_max_match: "此联赛内的赛事超出最高可选择场次，<br />请展开联赛后选择所需的赛事。",

  button_skip: "跳过导览",
  button_previous: "上一页",
  button_next: "下一页",
  button_stop: "完成",
  button_continue: "继续",
  tour_content_1: "<h6>欢迎来到WBET锦标赛</h6><p>我们很高兴宣布一个令人兴奋的新锦标赛，专为我们网站的支持者而设。</p>",
  tour_content_2: "<h6>公共房间</h6><p>会员之间进行竞技游戏，通常需要支付参赛费。</p>",
  tour_content_3: "<h6>私人房间</h6><p>会员可以通过邀请码开设房间与朋友一起游戏。</p>",
  tour_content_4: "<h6>公共免费房间</h6><p>由各种组织在特殊活动期间专门为会员举办，提供免费参与。</p>",
  tour_content_5: "<h6>可加入的总玩家数和费用</h6><p>玩家：房间容纳人数。</p><p>参赛费：根据房间提供的基准（账户持有人的货币）。</p>",

  tour_content_6: "<h6>房间详情</h6><p>点击此处预览房间统计数据并加入房间。</p>",
  tour_content_7: "<h6>奖金池详情</h6><p>获胜者的总奖池金额和独特的房间ID供搜索使用。</p>",
  tour_content_8: "<h6>房间状态详情</h6><p>显示房间状态和最后加入时间。</p>",
  tour_content_9: "<h6>创建私人房间</h6><p>创建私人房间并邀请朋友通过邀请码加入。</p>",
  tour_content_10: "<h6>积分排名</h6><p>此功能用于显示玩家的积分，并追踪结果。</p>",
};
